module.exports = __webpack_public_path__ + "static/media/earhear-5.a32a76ad.png";